import { render, staticRenderFns } from "./PreLoader.vue?vue&type=template&id=c858b5f4&scoped=true&"
import script from "./PreLoader.vue?vue&type=script&lang=js&"
export * from "./PreLoader.vue?vue&type=script&lang=js&"
import style0 from "./PreLoader.vue?vue&type=style&index=0&id=c858b5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c858b5f4",
  null
  
)

export default component.exports